<template>
  <!--查看预警通报产品问题产品详情的弹框-->
  <el-dialog  top="4vh" :close-on-click-modal="false" class="abow_dialog" v-dialog-drag
              :append-to-body="true"
              :visible.sync="faultyDialog"
              @close="handleClose"
>
    <div class="details" style="height: 95%;">
      <el-scrollbar style="height: 100%;">
        <!-- 有手工录入和非手工之分-->
        <!--现在改为是否手工录入1 非手工录入产品检查 2 手工录入产品检查 2019-11-21   之前是1手工 0 非手工-->
        <!--非手工-->
        <div v-show="hand == '1'">
          <!--种子-->
          <div class="wrapper" v-show="productInfos.checkType === '1'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.varietyName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">审定证号</div>
                  <div class="label_val_right"> {{productInfos.judgementNo}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">审定意见</div>
                  <div class="label_val_right"> {{productInfos.judgementSuggestion?productInfos.judgementSuggestion:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">审定样本号</div>
                  <div class="label_val_right"> {{productInfos.judgementSampleNo?productInfos.judgementSampleNo:'无'}}</div>
                </li>
              </ul>
            </div>
            <div style="margin-top: 15px">
              <div class="info_header pro_bg">产品信息</div>
              <ul class="info pro">
                <li class="lablel_li " >
                  <div class="label">产品批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?outInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">检测日期</div>
                  <div class="label_val_right"> {{productInfos.produceTime}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--农药-->
          <div class="wrapper" v-show="productInfos.checkType === '2'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">登记证号</div>
                  <div class="label_val_right"> {{productInfos.registerNumber}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效起始日</div>
                  <div class="label_val_right"> {{productInfos.validityStart?productInfos.validityStart:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效截止日</div>
                  <div class="label_val_right"> {{productInfos.validityEnd?productInfos.validityEnd:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">标签信息</div>
                  <div class="label_val_right"><a :href="productInfos.labelUrl" target="_blank"> 标签详情</a></div>
                </li>
              </ul>
            </div>
            <div style="margin-top: 15px">
              <div class="info_header pro_bg">产品信息</div>
              <ul class="info pro">
                <li class="lablel_li " >
                  <div class="label">产品批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.produceTime}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">分装日期</div>
                  <div class="label_val_right"> {{productInfos.partialShipmentsDate?productInfos.partialShipmentsDate:'无'}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--肥料-->
          <div class="wrapper" v-show="productInfos.checkType === '3'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">产品名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">登记证号</div>
                  <div class="label_val_right"> {{productInfos.registerNumber}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产企业</div>
                  <div class="label_val_right"> {{productInfos.productEnterprise?productInfos.productEnterprise:'无'}}</div>
                </li>
              </ul>
            </div>
            <div style="margin-top: 15px">
              <div class="info_header pro_bg">产品信息</div>
              <ul class="info pro">
                <li class="lablel_li " >
                  <div class="label">产品批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.produceTime}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">分装日期</div>
                  <div class="label_val_right"> {{productInfos.partialShipmentsDate?productInfos.partialShipmentsDate:'无'}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--兽药-->
          <div class="wrapper" v-show="productInfos.checkType === '4'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">通用名</div>
                  <div class="label_val_right"> {{productInfos.tym}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">规格</div>
                  <div class="label_val_right"> {{productInfos.gg?productInfos.gg:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">商品名</div>
                  <div class="label_val_right"> {{productInfos.spm?productInfos.spm:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">批准文号</div>
                  <div class="label_val_right"> {{productInfos.pzwh?productInfos.pzwh:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">批准生产起始日期</div>
                  <div class="label_val_right"> {{productInfos.pzrq?productInfos.pzrq:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">批准生产截止日期</div>
                  <div class="label_val_right"> {{productInfos.yxq?productInfos.yxq:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产企业信息</div>
                  <div class="label_val_right"> {{productInfos.judgementSampleNo?productInfos.judgementSampleNo:'无'}}</div>
                </li>
              </ul>
            </div>
            <div style="margin-top: 15px">
              <div class="info_header pro_bg">产品信息</div>
              <ul class="info pro">
                <li class="lablel_li " >
                  <div class="label">产品批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.produceTime}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--饲料和饲料添加剂生产 待解-->
          <div class="wrapper" v-show="productInfos.checkType === '5'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">登记证号</div>
                  <div class="label_val_right"> {{productInfos.registerNumber}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效起始日</div>
                  <div class="label_val_right"> {{productInfos.validityStart?productInfos.validityStart:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效截止日</div>
                  <div class="label_val_right"> {{productInfos.validityEnd?productInfos.validityEnd:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">标签信息</div>
                  <div class="label_val_right"><a :href="productInfos.labelUrl" target="_blank"> 标签详情</a></div>
                </li>
              </ul>
            </div>
            <div style="margin-top: 15px">
              <div class="info_header pro_bg">产品信息</div>
              <ul class="info pro">
                <li class="lablel_li " >
                  <div class="label">产品批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.produceTime}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">分装日期</div>
                  <div class="label_val_right"> {{productInfos.partialShipmentsDate?productInfos.partialShipmentsDate:'无'}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--种畜禽 待解-->
          <div class="wrapper" v-show="productInfos.checkType === '6'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">登记证号</div>
                  <div class="label_val_right"> {{productInfos.registerNumber}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效起始日</div>
                  <div class="label_val_right"> {{productInfos.validityStart?productInfos.validityStart:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效截止日</div>
                  <div class="label_val_right"> {{productInfos.validityEnd?productInfos.validityEnd:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">标签信息</div>
                  <div class="label_val_right"><a :href="productInfos.labelUrl" target="_blank"> 标签详情</a></div>
                </li>
              </ul>
            </div>
            <div style="margin-top: 15px">
              <div class="info_header pro_bg">产品信息</div>
              <ul class="info pro">
                <li class="lablel_li " >
                  <div class="label">产品批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.produceTime}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">分装日期</div>
                  <div class="label_val_right"> {{productInfos.partialShipmentsDate?productInfos.partialShipmentsDate:'无'}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--农产品待解-->
          <div class="wrapper" v-show="productInfos.checkType === '7'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">登记证号</div>
                  <div class="label_val_right"> {{productInfos.registerNumber}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效起始日</div>
                  <div class="label_val_right"> {{productInfos.validityStart?productInfos.validityStart:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效截止日</div>
                  <div class="label_val_right"> {{productInfos.validityEnd?productInfos.validityEnd:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">标签信息</div>
                  <div class="label_val_right"><a :href="productInfos.labelUrl" target="_blank"> 标签详情</a></div>
                </li>
              </ul>
            </div>
            <div style="margin-top: 15px">
              <div class="info_header pro_bg">产品信息</div>
              <ul class="info pro">
                <li class="lablel_li " >
                  <div class="label">产品批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.produceTime}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">分装日期</div>
                  <div class="label_val_right"> {{productInfos.partialShipmentsDate?productInfos.partialShipmentsDate:'无'}}</div>
                </li>
              </ul>
            </div>
          </div>
          <!--农业转基因生物安全待解-->
          <div class="wrapper" v-show="productInfos.checkType === '8'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">登记证号</div>
                  <div class="label_val_right"> {{productInfos.registerNumber}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效起始日</div>
                  <div class="label_val_right"> {{productInfos.validityStart?productInfos.validityStart:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">有效截止日</div>
                  <div class="label_val_right"> {{productInfos.validityEnd?productInfos.validityEnd:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">标签信息</div>
                  <div class="label_val_right"><a :href="productInfos.labelUrl" target="_blank"> 标签详情</a></div>
                </li>
              </ul>
            </div>
            <div style="margin-top: 15px">
              <div class="info_header pro_bg">产品信息</div>
              <ul class="info pro">
                <li class="lablel_li " >
                  <div class="label">产品批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.produceTime}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">分装日期</div>
                  <div class="label_val_right"> {{productInfos.partialShipmentsDate?productInfos.partialShipmentsDate:'无'}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--手工-->
        <div v-show="hand==='2'">
          <!--种子-->
          <div class="wrapper" v-show="productInfos.checkType === '1'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">作物名称</div>
                  <div class="label_val_right"> {{productInfos.cropName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">审定编号</div>
                  <div class="label_val_right"> {{productInfos.authorizedNumber?productInfos.authorizedNumber:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">检测日期</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>

          </div>
          <!--农药 数据-->
          <div class="wrapper" v-show="productInfos.checkType === '2'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab">
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">登记证号</div>
                  <div class="label_val_right"> {{productInfos.registrationNumber}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">分装日期</div>
                  <div class="label_val_right"> {{productInfos.partialShipmentsDate?productInfos.partialShipmentsDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>

          </div>
          <!--肥料-->
          <div class="wrapper" v-show="productInfos.checkType === '3'">
            <div >
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">产品名称</div>
                  <div class="label_val_right"> {{productInfos.productName?productInfos.productName:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">产品形态</div>
                  <div class="label_val_right"> {{productInfos.productStatus?productInfos.productStatus:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">登记证号</div>
                  <div class="label_val_right"> {{productInfos.registrationNumber?productInfos.registrationNumber:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产企业</div>
                  <div class="label_val_right"> {{productInfos.productEnterprise}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">肥料商标</div>
                  <div class="label_val_right"> {{productInfos.trademark?productInfos.trademark:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">执行标准</div>
                  <div class="label_val_right"> {{productInfos.executionStandard?productInfos.executionStandard:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">其他事项</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.otherMatters?productInfos.otherMatters:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                  <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                    <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                  </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--兽药 数据-->
          <div class="wrapper" v-show="productInfos.checkType === '4'">
            <div>
              <div class="info_header label_bg">标签信息</div>
              <ul class="info lab" >

                <li class="lablel_li" >
                  <div class="label">通用名</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">商品名</div>
                  <div class="label_val_right"> {{productInfos.sProductName}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">规格</div>
                  <div class="label_val_right"> {{productInfos.specifications?productInfos.specifications:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">批准文号</div>
                  <div class="label_val_right"> {{productInfos.approvalNumber?productInfos.approvalNumber:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>

          </div>
          <!--饲料和饲料添加剂生产-->
          <div class="wrapper" v-show="productInfos.checkType === '5'">
            <div >
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">产品名称</div>
                  <div class="label_val_right"> {{productInfos.productName?productInfos.productName:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">许可证明编号</div>
                  <div class="label_val_right"> {{productInfos.registrationNumber}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">净含量</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.netContent?productInfos.netContent:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--种畜禽-->
          <div class="wrapper" v-show="productInfos.checkType === '6'">
            <div>
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">种类名称</div>
                  <div class="label_val_right"> {{productInfos.cropName?productInfos.cropName:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">出生日期</div>
                  <div class="label_val_right">  {{productInfos.checkDate ? productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">代系</div>
                  <div class="label_val_right"> {{productInfos.specifications?productInfos.specifications:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">品种特征</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.describetion?productInfos.describetion:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--农产品-->
          <div class="wrapper" v-show="productInfos.checkType === '7'">
            <div>
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">种类名称</div>
                  <div class="label_val_right"> {{productInfos.cropName?productInfos.cropName:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">品种名称</div>
                  <div class="label_val_right"> {{productInfos.productName}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">出生日期</div>
                  <div class="label_val_right">  {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">品种特征</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.describetion?productInfos.describetion:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--农业转基因生物安全-->
          <div class="wrapper" v-show="productInfos.checkType === '8'">
            <div >
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">产品名称</div>
                  <div class="label_val_right"> {{productInfos.productName?productInfos.productName:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">生产企业</div>
                  <div class="label_val_right"> {{productInfos.productEnterprise}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产批号</div>
                  <div class="label_val_right"> {{productInfos.productNumber?productInfos.productNumber:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">生产日期</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">其他事项</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.otherMatters?productInfos.otherMatters:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--农基-->
          <div class="wrapper" v-show="productInfos.checkType === '10'">
            <div >
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">号牌号码</div>
                  <div class="label_val_right"> {{productInfos.productName?productInfos.productName:'无'}}</div>
                </li>
                <li class="lablel_li" >
                  <div class="label">所有人</div>
                  <div class="label_val_right"> {{productInfos.vender?productInfos.vender:'无'}}</div>
                </li>

                <li class="lablel_li">
                  <div class="label">注册登记日期</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">发证机关</div>
                  <div class="label_val_right"> {{productInfos.productEnterprise?productInfos.productEnterprise:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">检验有效日期</div>
                  <div class="label_val_right"> {{productInfos.partialShipmentsDate?productInfos.partialShipmentsDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">品牌型号</div>
                  <div class="label_val_right"> {{productInfos.cropName?productInfos.cropName:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">发动机号</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.approvalNumber?productInfos.approvalNumber:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--动防-->
          <div class="wrapper" v-show="productInfos.checkType === '12'">
            <div >
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">检查产品</div>
                  <div class="label_val_right">
                    <span v-if="productInfos.productStatus === 'DA'">动物A</span>
                    <span v-else-if="productInfos.productStatus === 'DB'">动物B</span>
                    <span v-else-if="productInfos.productStatus === 'CB'">产品B</span>
                    <span v-else-if="productInfos.productStatus === 'CA'">产品A</span>
                    <span v-else>无</span>
                    </div>
                </li>
                <li class="lablel_li" >
                  <div class="label">{{(productInfos.productStatus === 'DA' || productInfos.productStatus === 'DB')? '动物类型' : '产品类型'}}
                  </div>
                  <div class="label_val_right">
                    <span v-if="(productInfos.productStatus=== 'DA' || productInfos.productStatus === 'DB')">{{productInfos.cropName}}</span>
                    <span v-else-if="(productInfos.productStatus === 'CA' || productInfos.productStatus === 'CB')">{{productInfos.productName}}</span>
                    <span v-else>无</span>
                 </div>
                </li>
                <li class="lablel_li">
                  <div class="label">数量及单位</div>
                  <div class="label_val_right"> {{productInfos.specifications?productInfos.specifications:'无'}}</div>
                </li>
                <li class="lablel_li" v-show="productInfos.productStatus === 'CA' || productInfos.productStatus === 'CB'">
                  <div class="label">生产单位名称</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li" v-show="productInfos.productStatus === 'CA' || productInfos.productStatus === 'CB'">
                  <div class="label">生产单位地址</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">其他</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.otherMatters?productInfos.otherMatters:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--植物检疫 【13】-->
          <div class="wrapper" v-show="productInfos.checkType === '13'">
            <div >
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">检查产品</div>
                  <div class="label_val_right"> {{productInfos.productName?productInfos.productName:'无'}}</div>
                </li>

                <li class="lablel_li">
                  <div class="label">产品数量</div>
                  <div class="label_val_right"> {{productInfos.specifications?productInfos.specifications:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">其他</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.otherMatters?productInfos.otherMatters:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--渔业陆上 【16】-->
          <div class="wrapper" v-show="productInfos.checkType === '16'">
            <div >
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">渔具名称</div>
                  <div class="label_val_right"> {{productInfos.productName?productInfos.productName:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">品牌</div>
                  <div class="label_val_right"> {{productInfos.cropName?productInfos.cropName:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label"> 生产厂家 </div>
                  <div class="label_val_right"> {{productInfos.productEnterprise?productInfos.productEnterprise:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">数量</div>
                  <div class="label_val_right"> {{productInfos.specifications?productInfos.specifications:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">其他</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.otherMatters?productInfos.otherMatters:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!--畜禽屠宰【15-->
          <div class="wrapper" v-show="productInfos.checkType === '15'">
            <div >
              <div class="info_header label_bg">产品信息</div>
              <ul class="info lab" >
                <li class="lablel_li" >
                  <div class="label">检查产品</div>
                  <div class="label_val_right">
                    <span v-if="productInfos.productStatus === 'DA'">动物A</span>
                    <span v-else-if="productInfos.productStatus === 'DB'">动物B</span>
                    <span v-else-if="productInfos.productStatus === 'CB'">产品B</span>
                    <span v-else-if="productInfos.productStatus === 'CA'">产品A</span>
                    <span v-else>无</span>
                  </div>
                </li>
                <li class="lablel_li" >
                  <div class="label">{{(productInfos.productStatus === 'DA' || productInfos.productStatus === 'DB')? '动物类型' : '产品类型'}}
                  </div>
                  <div class="label_val_right">
                    <span v-if="(productInfos.productStatus=== 'DA' || productInfos.productStatus === 'DB')">{{productInfos.cropName}}</span>
                    <span v-else-if="(productInfos.productStatus === 'CA' || productInfos.productStatus === 'CB')">{{productInfos.productName}}</span>
                    <span v-else>无</span>
                  </div>
                </li>
                <li class="lablel_li">
                  <div class="label">数量及单位</div>
                  <div class="label_val_right"> {{productInfos.specifications?productInfos.specifications:'无'}}</div>
                </li>
                <li class="lablel_li" v-show="productInfos.productStatus === 'CA' || productInfos.productStatus === 'CB'">
                  <div class="label">生产单位名称</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li" v-show="productInfos.productStatus === 'CA' || productInfos.productStatus === 'CB'">
                  <div class="label">生产单位地址</div>
                  <div class="label_val_right"> {{productInfos.checkDate?productInfos.checkDate:'无'}}</div>
                </li>
                <li class="lablel_li">
                  <div class="label">其他</div>
                  <div class="label_val_right" style="min-height: 30px"> {{productInfos.otherMatters?productInfos.otherMatters:'无'}}</div>
                </li>
                <li >
                  <div style="margin: 8px auto;width: 94%;">
                    <viewer v-if="productInfos.imgUrl"  >
                      <div v-if="productInfos.imgUrl.split(',').length >1">
                      <span v-for="(imgs,idex) in productInfos.imgUrl.split(',')" :key="idex" >
                        <img style="width: 45%;height: 200px;border-radius: 5px;margin: 5px" :src="textImgBase+imgs" alt=""  >
                      </span>
                      </div>
                      <div v-else>
                        <img style="width: 100%;height: 200px;border-radius: 5px" :src="textImgBase+productInfos.imgUrl" alt="" >
                      </div>
                    </viewer>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>

  </el-dialog>
</template>

<script>

export default {
  name: 'viewFaultyProduct',
  props: {
    viewfaultyDialog: Boolean,
    viewInfos: Object,
    outInfos: {}, // 非接口，外部带来的数据
    hand: String, // 手工 非手工
    proType: String, // 检查记录表的产品查看 ，还是预警通报的产品查看
  },
  data() {
    return {
      faultyDialog: this.viewfaultyDialog,
      productInfos: {},
      textImgBase: this.global.textImgBase,
    };
  },
  methods: {
    handleClose() {
      this.faultyDialog = false;
      this.$emit('viewClose', this.faultyDialog);
    },
    initProductInfos() {
      this.productInfos = this.viewInfos;
      for (const key in this.outInfos) {
        this.productInfos[key] = this.outInfos[key];
      }
    },
  },
  mounted() {
    this.initProductInfos();
  },
};
</script>

<style scoped>
  @import '../../assets/reset.css';
  @import '../../assets/dialog.css';
  @import "../../assets/selfDefineDialog.css";
  ul,ul li{
    margin: 0;padding: 0;list-style: none;
  }
  a{
    text-decoration: none;
    color: #0066cc;
  }
  .abow_dialog.el-dialog__wrapper >>> .el-dialog__header{
    padding: 0px!important;
  }
  .el-dialog__wrapper >>> .el-dialog__header{
    padding: 0px!important;
  }
  .abow_dialog  >>> .el-dialog__body{
    top: 43px!important;
  }
  .wrapper{
    width: 95%;height: 100%;margin: auto;padding: 5px;
  }
  .info_header{
    height: 30px;line-height: 30px;text-align: center;border-top-left-radius: 5px;border-top-right-radius: 5px;
  }
  .label_bg{
    background: #e1e8f9;
  }
  .lab .lablel_li{
    border-bottom: 1px solid #edf1fc;
  }
  .pro_bg{
    background: #d2cde0;
  }
  .pro .lablel_li{
    border-bottom: 1px solid #e1e6e9;
  }
  .info{
     border: 1px solid #e1e8f9;border-top: none; padding: 5px 0;
  }
  .lablel_li{
    display: flex;flex-wrap: nowrap;justify-content:center; margin-bottom: 5px;margin-right: 8px;margin-left: 8px;
  }
  .lablel_li  .label{
    width: 30%;min-height: 24px;line-height: 24px;align-self: center;
  }
  .lablel_li  .label_val_right{
    text-align: right;width: 60%;min-height: 24px;line-height: 24px;
    flex-grow: 1;
  }
  ul li:last-child{
    border-bottom: none!important;
  }

  .detItem{
    /*width: 280px;*/
    width: 40%;
    height: 40px;
    border-bottom: 1px solid #f4f4f5;
    border-radius: 3px;
    float: left;
    margin: 0px 10px;
    list-style: none;
  }
  .detItem >.icon{
    width: 40px;
    height: 40px;
    float: left;
  }
  .detItem >.icon >span{
    margin: 14px 11px;
  }
  .detItem >.lab{
    display: inline-block;
    float: left;
    line-height: 40px;

  }
  .detItem >.info {
    padding-left: 15px;
    color: darkslategrey;
    line-height: 40px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;

  }
  .detItem:hover{
    background: #ffffff;
    border-bottom: 1px solid #f0f9eb;
  }

</style>
